var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('ExamList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }